import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  ShoppingBagIcon, 
  CubeIcon,
  UserIcon,
  PlusIcon
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  ShoppingBagIcon as ShoppingBagIconSolid,
  CubeIcon as CubeIconSolid,
  UserIcon as UserIconSolid
} from '@heroicons/react/24/solid';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      name: 'Accueil',
      path: '/dashboard',
      icon: HomeIcon,
      iconSolid: HomeIconSolid
    },
    {
      name: 'Produits',
      path: '/products',
      icon: CubeIcon,
      iconSolid: CubeIconSolid
    },
    {
      name: 'Liste de course',
      path: '/shopping-list',
      icon: ShoppingBagIcon,
      iconSolid: ShoppingBagIconSolid
    },
    {
      name: 'Profil',
      path: '/profile',
      icon: UserIcon,
      iconSolid: UserIconSolid
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleAddProduct = () => {
    navigate('/add-product');
  };

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center py-2 relative">
        {/* Boutons de navigation normaux */}
        {navItems.map((item) => {
          const active = isActive(item.path);
          const IconComponent = active ? item.iconSolid : item.icon;
          
          return (
            <button
              key={item.name}
              onClick={() => handleNavigation(item.path)}
              className={`flex flex-col items-center justify-center py-2 px-3 min-w-0 flex-1 ${
                active 
                  ? 'text-primary' 
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <IconComponent className="w-6 h-6 mb-1" />
              <span className={`text-xs font-medium ${
                active ? 'text-primary' : 'text-gray-600'
              }`}>
                {item.name}
              </span>
            </button>
          );
        })}

        {/* Bouton flottant "+" au milieu */}
        <button
          onClick={handleAddProduct}
          className="absolute left-1/2 transform -translate-x-1/2 -translate-y-8 bg-primary hover:bg-primary-dark text-white rounded-full p-4 shadow-lg transition-all duration-200 hover:scale-110"
          title="Ajouter un produit"
        >
          <PlusIcon className="w-8 h-8" />
        </button>
      </div>
    </div>
  );
};

export default MobileBottomNav; 